import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, auth } from "../firebase";
import {
  doc,
  getDoc
} from "firebase/firestore";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import logo from "../New_Logo.png";
import BackHomeButton from "../components/BackHomeButton";

function SchoolLogin() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showReset, setShowReset] = useState(false);

  const handleNavigation = (path, state = {}) => {
    navigate(path, { state });
  };

  // ✅ LOGIN USING FIREBASE AUTH
  const handleLogin = async () => {
    if (!username || !password) {
      alert("Please enter username and password");
      return;
    }

    try {
      const docRef = doc(db, "School_Login", username);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        alert("Invalid username");
        return;
      }

      const email = docSnap.data().email;
      const user_persona = docSnap.data().role;

      await signInWithEmailAndPassword(auth, email, password);

      handleNavigation("/Old_Home", { persona: user_persona });

    } catch (error) {
      alert(error.message);
    }
  };

  // ✅ PASSWORD RESET
  const handleResetPassword = async () => {
    if (!username) {
      alert("Enter your username first");
      return;
    }

    try {
      const docRef = doc(db, "School_Login", username);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        alert("User not found");
        return;
      }

      const email = docSnap.data().email;

      await sendPasswordResetEmail(auth, email);

      alert("Password reset email sent successfully.");
      setShowReset(false);

    } catch (error) {
      alert(error.message);
    }
  };

return (
    <div className="min-h-screen bg-gray-50 lg:bg-gray-100 flex items-center justify-center px-4 sm:px-6 relative overflow-hidden">
      
      {/* Main Container Card */}
      <div className="w-full max-w-md lg:max-w-4xl bg-white rounded-2xl shadow-xl lg:shadow-2xl relative flex flex-col lg:flex-row overflow-hidden z-10">
        
        {/* Back Button (Absolute positioned to stay out of flow) */}
        <div className="absolute top-4 left-4 lg:top-6 lg:left-6 z-20">
          <BackHomeButton />
        </div>

        {/* --- DESKTOP ONLY: Left Branding Panel --- */}
        <div className="hidden lg:flex w-1/2 bg-gradient-to-br from-blue-600 to-blue-800 p-12 flex-col items-center justify-center text-center relative overflow-hidden">
          {/* Subtle background shapes for depth */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-y-1/2 translate-x-1/3"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white opacity-5 rounded-full translate-y-1/3 -translate-x-1/4"></div>

          <div className="w-40 h-40 rounded-full bg-white/10 p-4 shadow-xl border border-white/20 flex items-center justify-center mb-8 backdrop-blur-sm z-10">
            <img
              src={logo}
              alt="Logo"
              className="w-full h-full object-contain rounded-full bg-white shadow-inner"
            />
          </div>
          <h1 className="text-4xl font-extrabold text-white tracking-tight z-10 mb-2">
            Eascode
          </h1>
          <p className="text-blue-100 italic text-lg z-10">
            Empowering Teachers with every click
          </p>
        </div>

        {/* --- MOBILE & DESKTOP: Right Form Panel --- */}
        <div className="w-full lg:w-1/2 p-8 lg:p-14 flex flex-col justify-center">
          
          {/* Mobile Branding (Hidden on Desktop) */}
          <div className="flex flex-col items-center text-center mb-8 lg:hidden mt-6">
            <div className="w-28 h-28 rounded-full bg-white p-3 shadow-md border border-gray-100 flex items-center justify-center mb-4">
              <img
                src={logo}
                alt="Logo"
                className="w-full h-full object-contain rounded-full"
              />
            </div>
            <h1 className="text-2xl font-bold text-gray-800">
              Eascode
            </h1>
            <p className="text-gray-500 italic text-sm mt-1">
              Empowering Teachers with every click
            </p>
          </div>

          {/* Login / Reset Logic Box */}
          <div className="space-y-5 lg:space-y-6">
            
            {/* Contextual Desktop Heading */}
            <div className="text-center lg:text-left">
              <h2 className="hidden lg:block text-3xl font-bold text-gray-800 mb-1">
                Welcome Back
              </h2>
              <p className="hidden lg:block text-gray-500 text-sm mb-6">
                Please enter your details to sign in.
              </p>
              
              {/* Mobile Heading */}
              <h2 className="text-lg font-semibold text-center lg:hidden text-gray-700 mb-4">
                Teacher & Admin Login
              </h2>
            </div>

            {!showReset ? (
              <>
                <div className="space-y-4">
                  <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="w-full px-4 py-3 lg:py-4 lg:px-5 lg:text-base rounded-xl border border-gray-200 bg-gray-50 hover:bg-white focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  />

                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-3 lg:py-4 lg:px-5 lg:text-base rounded-xl border border-gray-200 bg-gray-50 hover:bg-white focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  />
                </div>

                <div className="flex justify-end lg:justify-between items-center mt-2 lg:mt-4">
                  <p className="hidden lg:block text-sm text-gray-500 font-medium">
                    Teacher & Admin Access
                  </p>
                  <p
                    className="text-blue-600 text-sm font-medium cursor-pointer hover:text-blue-800 hover:underline transition-colors"
                    onClick={() => setShowReset(true)}
                  >
                    Forgot Password?
                  </p>
                </div>

                <button
                  onClick={handleLogin}
                  className="w-full py-3 lg:py-4 mt-4 lg:text-lg rounded-xl font-bold
                             bg-blue-600 hover:bg-blue-700
                             text-white shadow-lg hover:shadow-xl
                             transition-all duration-300
                             hover:-translate-y-1 active:scale-95"
                >
                  Login
                </button>
              </>
            ) : (
              <>
                <div className="space-y-4">
                  <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="w-full px-4 py-3 lg:py-4 lg:px-5 lg:text-base rounded-xl border border-gray-200 bg-gray-50 hover:bg-white focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  />
                </div>

                <button
                  onClick={handleResetPassword}
                  className="w-full py-3 lg:py-4 mt-4 lg:text-lg rounded-xl font-bold
                             bg-blue-600 hover:bg-blue-700
                             text-white shadow-lg hover:shadow-xl
                             transition-all duration-300
                             hover:-translate-y-1 active:scale-95"
                >
                  Send Reset Email
                </button>

                <div className="text-center mt-6">
                  <p
                    className="inline-flex items-center text-gray-600 text-sm font-medium cursor-pointer hover:text-blue-700 transition-colors"
                    onClick={() => setShowReset(false)}
                  >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                    </svg>
                    Back to Login
                  </p>
                </div>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default SchoolLogin;